module.exports = __webpack_public_path__ + "static/media/FundingChallenge.c66bcdf8.png";